import { render } from "./GrafComponent.vue?vue&type=template&id=6b855964"
import script from "./GrafComponent.vue?vue&type=script&lang=js"
export * from "./GrafComponent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__